import React from "react";
import { Link } from "react-router-dom";
import ReservationView from "../ReservationView";

/**
 * After reserving: the reference, what to pay and by when, and the three
 * things to do next. The same reservation lives in the guest's account.
 */
const Confirmation = ({ reservation: r }) => {
  const requested = r.status === "requested";
  return (
    <div className="bk-done">
      <header className="bk-done-head">
        <h1 className="bk-title hFont">{requested ? "We've got your request" : "Your place is held"}</h1>
        <p className="bk-sub">
          {requested
            ? "We'll be in touch to confirm it with you."
            : `We've emailed the details to ${r.guests[0]?.email || "you"}.`}
        </p>
      </header>

      <ReservationView r={r} />

      {!requested && (
        <section className="bk-next" aria-labelledby="next">
          <h2 id="next" className="bk-step-title">What happens next</h2>
          <ol>
            <li>
              <b>Pay to confirm</b>
              <span>Your room and place are held until then. You'll get a confirmation the moment it arrives.</span>
            </li>
            <li>
              <b>Medical screening</b>
              <span>Every guest gets a private link to a short medical screening. It's included in your retreat, and it's how experiences that need clearance are confirmed.</span>
            </li>
            <li>
              <b>Prepare and travel</b>
              <span>Your account has your booking, balance and everything you need before you fly to Colombia.</span>
            </li>
          </ol>
        </section>
      )}

      <div className="mk-actions">
        <Link className="mk-btn mk-btn--primary" to="/account">Go to my account</Link>
        <Link className="mk-btn mk-btn--ghost" to="/contact">Contact the team</Link>
      </div>
    </div>
  );
};

export default Confirmation;
